import { ModelBase } from 'store/model-base';

export class CmsLogin extends ModelBase {
    public static storeName: string = 'cmsLogin';

    public headline: string;
    public subhead: string;
}
